// extracted by mini-css-extract-plugin
export default {"dark":"HomePage_dark__NNkFL","root":"HomePage_root__baTyY","wrapper":"HomePage_wrapper__PSfw5"};